import
{
    GET_ALMANAC_BY_LATLON_FULFILLED,
    GET_ALMANAC_BY_LATLON_PENDING,
    GET_ALMANAC_BY_LATLON_REJECTED
} from '../actions/almanacActions';

const initialState = {
    almanacIsRefreshing: false
};

export function almanac(state = initialState, action)
{
    switch (action.type)
    {
        case GET_ALMANAC_BY_LATLON_PENDING:
        {
            return {
                ...state,
                almanacIsRefreshing: true
            };
        }

        case GET_ALMANAC_BY_LATLON_FULFILLED:
        {
            return {
                ...state,
                almanac: action.payload,
                lastError: {},
                almanacIsRefreshing: false
            };
        }

        case GET_ALMANAC_BY_LATLON_REJECTED:
        {
            return {
                ...state,
                almanac: undefined,
                lastError: action.payload,
                almanacIsRefreshing: false
            };
        }
        default:
        {
            return state;
        }
    }
}
